module.exports = __webpack_public_path__ + "static/media/ic_bar.b109dc1f.svg";